const lang = {
  page_title: 'シミュレーション編集',
  add_raw: '行の追加',
  save: '保存',
  cancel: 'キャンセル',
  default_input_text: '保存するシミュレーション名',
}

export default lang
